import { DataBean } from "../DataBean";

export class CertificateSheets extends DataBean {



    public async getInfoForTaxCertificateSheets(year:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getInfoForTaxCertificateSheets_Number", [year]);
    }
    
}